// extracted by mini-css-extract-plugin
export default {"root":"NotFound404_root__UPQhB"};